import type { IconComponent } from './icon'

export const GrowCoin: IconComponent = ({ className, color = 'white' }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <title>Grow Coin</title>
            <circle cx="12" cy="12.5713" r="9.5" stroke={color} strokeWidth="1.5" />
            <path
                d="M7.25 15.3213L10 12.5713L12 14.5713L15.5 11.0713"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="square"
            />
            <path
                d="M13.5 10.0713H14.5C15.6046 10.0713 16.5 10.9667 16.5 12.0713V13.0713"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="square"
            />
        </svg>
    )
}
